function normalizedPainTrend(rows) {
  return (rows || []).flatMap((row) => {
    if (row?.pain_score === null || row?.pain_score === undefined || String(row.pain_score).trim() === "") return [];
    const pain = Number(row.pain_score);
    if (!Number.isFinite(pain) || pain < 0 || pain > 10) return [];
    return [{ date: row.date, pain }];
  });
}

function shortDate(value) {
  if (!value) return "Check-in";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Check-in";
  return date.toLocaleDateString("en-AU", { day: "numeric", month: "short" });
}

export default function PainTrendChart({ painTrend, compact = false }) {
  const values = normalizedPainTrend(painTrend);
  if (values.length < 2) return null;

  const width = compact ? 120 : 640;
  const height = compact ? 34 : 190;
  const padding = compact ? { left: 3, right: 3, top: 3, bottom: 3 } : { left: 34, right: 14, top: 10, bottom: 28 };
  const chartWidth = width - padding.left - padding.right;
  const chartHeight = height - padding.top - padding.bottom;
  const points = values.map((row, index) => ({
    ...row,
    x: padding.left + (values.length === 1 ? 0 : index * chartWidth / (values.length - 1)),
    y: padding.top + ((10 - row.pain) / 10) * chartHeight,
  }));
  const pointString = points.map((point) => `${point.x},${point.y}`).join(" ");

  return <svg
    viewBox={`0 0 ${width} ${height}`}
    width="100%"
    height={height}
    preserveAspectRatio="none"
    className={compact ? "h-[34px] w-[120px]" : "h-[190px] min-h-[190px] w-full min-w-0"}
    role="img"
    aria-label={`${values.length} recorded pain scores from 0 to 10`}
    data-testid={compact ? "pain-sparkline" : "pain-trend-chart"}
  >
    {!compact && [0, 5, 10].map((score) => {
      const y = padding.top + ((10 - score) / 10) * chartHeight;
      return <g key={score}><line x1={padding.left} x2={width - padding.right} y1={y} y2={y} stroke="#e2e8f0" strokeDasharray="4 4" /><text x="3" y={y + 4} fontSize="11" fill="#64748b">{score}</text></g>;
    })}
    <polyline points={pointString} fill="none" stroke="#0d9488" strokeWidth={compact ? 2.5 : 3} vectorEffect="non-scaling-stroke" />
    {points.map((point, index) => <circle key={`${point.date}-${index}`} cx={point.x} cy={point.y} r={compact ? 2.2 : 4} fill="#0d9488"><title>{shortDate(point.date)}: {point.pain}/10</title></circle>)}
    {!compact && <>
      <text x={padding.left} y={height - 6} fontSize="11" fill="#64748b">{shortDate(values[0].date)}</text>
      <text x={width - padding.right} y={height - 6} textAnchor="end" fontSize="11" fill="#64748b">{shortDate(values[values.length - 1].date)}</text>
    </>}
  </svg>;
}

export { normalizedPainTrend };
